import React, { useState } from "react";
import "./Knowledge.css";
import LanguageIcon from "@mui/icons-material/Language";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Blog from "./Blog";

const Knowledge = () => {
  const [showAccordion, setShowAccordion] = useState(false);

  return (
    <div className="knowledge-container">
      <div className="knowledge-header">
        <h1>
          Knowledge Base
        </h1>
        <p>
          Aspiron is a cutting-edge, robust digital campus automation management
          platform designed to revolutionize the way higher education
          institutions are managed and operated.
        </p>
      </div>

      <div className="knowledge-btn-container">
        <button onClick={() => setShowAccordion(false)} className="knowledge-btn">
          <LanguageIcon sx={{ color: "gray" }} /> &nbsp;Blogs
        </button>
        <button onClick={() => setShowAccordion(true)} className="knowledge-btn">
          <HelpOutlineIcon sx={{ color: "gray" }} /> &nbsp; FAQ's
        </button>
      </div>

      <div className="accordion-container">
        {showAccordion ? (
          <>
            <Accordion className="accordion-item">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: "bold" }}
              >
                How can Aspiron’s digital solutions benefit colleges?
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <p>
                  Aspiron’s digital solutions transform college operations by
                  enhancing efficiency, improving communication, and delivering
                  a seamless student experience. Our tools foster better
                  collaboration among departments, enable data-driven
                  decision-making, reduce manual workload, and empower
                  institutions to scale their operations effortlessly.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion className="accordion-item">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: "bold" }}
              >
                What key features does Aspiron provide for colleges?
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <p>
                  Aspiron offers an all-in-one platform designed to meet the
                  diverse needs of colleges, including:
                </p>
                <ul>
                  <li>Centralized student information management.</li>
                  <li>Dynamic course scheduling and management tools.</li>
                  <li>
                    AI-powered learning management systems for online and hybrid
                    learning.
                  </li>
                  <li>
                    Integrated communication channels for faculty, students, and
                    administrators.
                  </li>
                  <li>
                    Advanced tracking and reporting of academic performance.
                  </li>
                  <li>Streamlined admission and enrollment processes.</li>
                  <li>
                    Comprehensive fee collection and financial management
                    systems.
                  </li>
                  <li>Digital libraries and resource hubs.</li>
                  <li>
                    Automated assessment, grading, and certification workflows.
                  </li>
                  <li>Effective hostel and campus activity management.</li>
                </ul>
              </AccordionDetails>
            </Accordion>
            <Accordion className="accordion-item">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: "bold" }}
              >
                Can Aspiron’s platform be customized for our institution?
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <p>
                  Yes, Aspiron’s platform is designed to adapt to your unique
                  needs. We understand that no two colleges are the same, and we
                  work closely with you to customize features, workflows, and
                  interfaces that align perfectly with your processes and goals.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion className="accordion-item">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: "bold" }}
              >
                How does Aspiron ensure data security?
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <p>
                  At Aspiron, data security is a core principle. We use
                  state-of-the-art encryption protocols, multi-level access
                  controls, regular system audits, and compliance with global
                  security standards. These measures ensure your institution’s
                  data remains secure and confidential.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion className="accordion-item">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: "bold" }}
              >
                How can colleges leverage Aspiron’s analytics for better
                outcomes?
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <p>
                  Aspiron’s built-in analytics provide actionable insights that
                  help institutions:
                </p>
                <ul>
                  <li>
                    Monitor student progress and identify areas for improvement.
                  </li>
                  <li>
                    Analyze course effectiveness and refine teaching strategies.
                  </li>
                  <li>
                    Make evidence-based decisions to enhance academic outcomes.
                  </li>
                  <li>
                    Optimize administrative operations with real-time
                    performance metrics.
                  </li>
                </ul>
              </AccordionDetails>
            </Accordion>
            <Accordion className="accordion-item">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: "bold" }}
              >
                How does Aspiron support student success?
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <p>
                  Aspiron’s platform is built to support students in multiple
                  ways, including:
                </p>
                <ul>
                  <li>
                    Personalized learning paths that cater to individual needs.
                  </li>
                  <li>
                    Real-time performance tracking and actionable feedback.
                  </li>
                  <li>
                    Access to additional study materials and digital resources.
                  </li>
                  <li>
                    Streamlined communication with faculty and support teams for
                    guidance.
                  </li>
                  <li>
                    By empowering students with the right tools and resources,
                    Aspiron helps them achieve their full potential.
                  </li>
                </ul>
              </AccordionDetails>
            </Accordion>
            <Accordion className="accordion-item">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: "bold" }}
              >
                How can our college get started with Aspiron?
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <p>
                  Starting your journey with Aspiron is simple! Visit
                  <a href="https://aspiron.ai/" className="Aspiron_blog">www.aspiron.ai</a> to connect with our team. We’ll help you assess
                  your needs, provide a customized demonstration of our
                  solutions, and guide you through a smooth implementation
                  process tailored to your institution.
                </p>
              </AccordionDetails>
            </Accordion>
          </>
        ) : (
          <div>
            <Blog />
          </div>
        )}
      </div>
    </div>
  );
};

export default Knowledge;
